import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { TradingOfferOperationStatus } from 'types/TradingOfferOperation';

import { statusBannerMap } from '../constants/tradingOfferOperationStatus';

type TradingOfferOperationDetailStatusBannerProps = {
  operationStatus: TradingOfferOperationStatus;
  sharesCount: number;
  shareClassName: string;
};

const TradingOfferOperationDetailStatusBanner: FC<
  TradingOfferOperationDetailStatusBannerProps
> = ({ operationStatus, sharesCount, shareClassName }) => {
  const { t } = useTranslate();

  const statusBanner =
    statusBannerMap[operationStatus] || statusBannerMap.PENDING;

  return (
    <div className={`alert alert-icon ${statusBanner.className} mb-4`}>
      <em className={`icon ni ${statusBanner.icon}`} />
      <div>
        <h6 className="alert-heading">{t(statusBanner.heading)}</h6>
        <p className="mb-0">
          {t(statusBanner.message, {
            shares: sharesCount,
            className: shareClassName,
          })}
        </p>
      </div>
    </div>
  );
};

export default TradingOfferOperationDetailStatusBanner;
